import { createFields } from '../helpers/createFields'

const consentsFields = createFields({
  marketingCommunicationConsentAccepted: {
    __type: 'checkbox',
    label: 'field.marketing_consent',
    name: 'marketingCommunicationConsentAccepted',
  },
  insuranceConsentAccepted: {
    __type: 'checkbox',
    label: 'field.insurance_consent',
    name: 'insuranceConsentAccepted',
  },
  confidentialityAgreementAccepted: {
    __type: 'checkbox',
    label: 'field.confidentiality_declaration',
    name: 'confidentialityAgreementAccepted',
    inputProps: {
      withText: true,
    },
  },
})

export default consentsFields
